import update from "immutability-helper";
import constants from "constants";
import {
  CLEAR_ADD_TO_CALLENDAR_LINKS,
  SAVE_SEARCHED_WEBINARS_TERMS,
  SET_ADD_TO_CALLENDAR_LINKS,
  SET_SYSTEM_FEEDBACKS,
  CLEAR_SYSTEM_FEEDBACKS,
  SET_SYSTEM_FEEDBACK,
  LOAD_WEBINARS_COMPLETE,
} from "../constants/actions";

const {
  ADD_WEBINARS,
  ADD_USERS_WEBINARS,
  UPCOMING_WEBINARS,
  CURRENT_WEBINARS,
  PREVIOUS_WEBINARS,
  LANDING_WEBINARS,
  LIVE_WEBINARS,
  UPDATE_WEBINAR,
  SET_TEMP_WEBINAR,
  GET_GALLERY,
  CLEAN_WEBINARS,
  CLEAN_USERS_WEBINARS,
  ADD_ADMIN_WEBINARS,
  ADD_ADMIN_DASHBOARD_WEBINARS,
  SET_WEBINARS,
  RECORDED_WEBINARS,
  USER_WEBINARS_AVAILABLE_YEARS,
  SET_USERS_WEBINARS,
  LOAD_WEBINAR_SUBSCRIPTION,
  SAVE_SEARCHED_WEBINARS,
  SEARCH_WEBINARS,
  GET_QUESTIONS_ON_WEBINAR,
  SAVE_QUESTIONS_ON_WEBINAR,
  SAVE_GALLERY,
  TOGGLE_GALLERY,
  LOAD_WEBINARS_SAGA,
  CLEAR_TEMP_WEBINAR,
} = constants;

const webinars = (
  webinars = {
    [UPCOMING_WEBINARS]: {
      values: [],
      page: 0,
      pages: 0,
      count: 0,
    },
    [CURRENT_WEBINARS]: {
      values: [],
      page: 0,
      pages: 0,
      count: 0,
    },
    [PREVIOUS_WEBINARS]: {
      values: [],
      page: 0,
      pages: 0,
      count: 0,
    },
    [LANDING_WEBINARS]: {
      values: [],
      page: 0,
      pages: 0,
      count: 0,
    },
    usersWebinars: {
      [RECORDED_WEBINARS]: {
        page: 0,
        pages: 0,
        values: [],
        cpds: 0,
        years: [],
      },
      [LIVE_WEBINARS]: {
        page: 0,
        pages: 0,
        values: [],
        cpds: 0,
        years: [],
      },
    },
    questionsWebinar: null,
    isQuestionsWebinarLoading: true,
    adminWebinars: {
      values: [],
      page: 1,
      total_pages: 0,
      query: {
        title: "",
        date_from: null,
        date_to: null,
        order: {
          created_at: "desc",
        },
      },
    },
    dashboardWebinars: {
      values: [],
      page: 1,
      total_pages: 0,
    },
    userWebinarsAvailableYears: [],
    tmp: {},
    calendarLinks: {},
    searchList: [],
    isSearching: false,
    isSearchResultsLoading: false,
    isLoading: false,
    loadingCounter: 0,
    terms: [],
    gallery: [],
    galleryOpen: false,
    isGalleryLoading: false,
    systemFeedbacks: {
      data: [],
      count: 0,
      totalPages: 0,
    },
    systemFeedback: {
      body: "",
      user_name: "",
    },
  },
  { type, webinarType, payload, page, pages, count },
) => {
  switch (type) {
    case GET_QUESTIONS_ON_WEBINAR:
      return {
        ...webinars,
        isQuestionsWebinarLoading: true,
        questionsWebinar: null,
      };
    case SAVE_QUESTIONS_ON_WEBINAR:
      return {
        ...webinars,
        isQuestionsWebinarLoading: false,
        questionsWebinar: payload.questionsWebinar,
      };
    case TOGGLE_GALLERY:
      return {
        ...webinars,
        galleryOpen: !webinars.galleryOpen,
      };
    case GET_GALLERY:
      return {
        ...webinars,
        isGalleryLoading: true,
      };
    case SAVE_GALLERY:
      return {
        ...webinars,
        gallery: payload.gallery,
        isGalleryLoading: false,
      };
    case ADD_WEBINARS:
      return {
        ...webinars,
        ...{
          [webinarType]: {
            values: update(webinars[webinarType].values, {
              $push: payload,
            }),
            page,
            pages,
            count,
          },
        },
      };
    case SET_WEBINARS:
      return {
        ...webinars,
        ...{
          [webinarType]: {
            ...webinars[webinarType],
            values: payload,
            count,
            // Preserve page/pages when not provided (e.g. setWebinars(type, values, count) only)
            page: page,
            pages: pages,
          },
        },
      };

    case SET_USERS_WEBINARS:
      return {
        ...webinars,
        ...{
          usersWebinars: {
            ...webinars.usersWebinars,
            [webinarType]: {
              ...webinars.usersWebinars[webinarType],
              page: page,
              pages: pages || payload.pages,
              years: payload.years,
              values: payload.webinars,
              cpds: payload.cpds,
            },
          },
        },
      };
    case ADD_USERS_WEBINARS:
      return {
        ...webinars,
        ...{
          usersWebinars: {
            ...webinars.usersWebinars,
            [webinarType]: {
              ...webinars.usersWebinars[webinarType],
              page: page,
              pages: pages || payload.pages,
              years: payload.years,
              values: update(webinars.usersWebinars[webinarType].values, {
                $push: payload.webinars,
              }),
              cpds: payload.cpds,
            },
          },
        },
      };
    case USER_WEBINARS_AVAILABLE_YEARS:
      return {
        ...webinars,
        userWebinarsAvailableYears: payload.userWebinarsAvailableYears,
      };

    case LOAD_WEBINAR_SUBSCRIPTION:
      return {
        ...webinars,
        ...{
          [UPCOMING_WEBINARS]: {
            ...webinars[UPCOMING_WEBINARS],
            subscriptions: {
              ...webinars[UPCOMING_WEBINARS].subscriptions,
              ...payload.subscriptionEvent,
            },
          },
        },
      };

    case UPDATE_WEBINAR:
      const webinarForUpdateId = payload.webinar.id;
      const replaceWith = (webinar) =>
        webinar.id == webinarForUpdateId ? payload.webinar : webinar;

      const tempWebinar =
        webinarForUpdateId == webinars.tmp.id ? payload.webinar : webinars.tmp;
      return {
        ...webinars,
        ...{
          [UPCOMING_WEBINARS]: {
            ...webinars[UPCOMING_WEBINARS],
            values: webinars[UPCOMING_WEBINARS].values.map(replaceWith),
          },
          [CURRENT_WEBINARS]: {
            ...webinars[CURRENT_WEBINARS],
            values: webinars[CURRENT_WEBINARS].values.map(replaceWith),
          },
          [PREVIOUS_WEBINARS]: {
            ...webinars[PREVIOUS_WEBINARS],
            values: webinars[PREVIOUS_WEBINARS].values.map(replaceWith),
          },
          usersWebinars: {
            ...webinars.usersWebinars,
            [PREVIOUS_WEBINARS]: {
              ...webinars.usersWebinars[RECORDED_WEBINARS],
              pages: (webinars.usersWebinars[RECORDED_WEBINARS] || {}).pages,
              values: (
                webinars.usersWebinars[RECORDED_WEBINARS] || { values: [] }
              ).values.map(replaceWith),
            },
            [LANDING_WEBINARS]: {
              ...webinars.usersWebinars[LANDING_WEBINARS],
              pages: (webinars.usersWebinars[LANDING_WEBINARS] || {}).pages,
              values: (
                webinars.usersWebinars[LANDING_WEBINARS] || { values: [] }
              ).values.map(replaceWith),
            },
          },
          tmp: tempWebinar,
        },
      };
    case SET_TEMP_WEBINAR:
      return {
        ...webinars,
        tmp: payload.webinar,
      };
    case CLEAN_WEBINARS:
      return {
        ...webinars,
        [UPCOMING_WEBINARS]: {
          values: [],
          page: 0,
          count: 0,
        },
        [CURRENT_WEBINARS]: {
          values: [],
          page: 0,
          count: 0,
        },
        [PREVIOUS_WEBINARS]: {
          values: [],
          page: 0,
          count: 0,
        },
        [LANDING_WEBINARS]: {
          values: [],
          page: 0,
          count: 0,
        },
        // isLoading: false,
      };
    case CLEAN_USERS_WEBINARS:
      return {
        ...webinars,
        usersWebinars: {
          [RECORDED_WEBINARS]: {
            page: 0,
            pages: 0,
            count: 0,
            values: [],
          },
          [LIVE_WEBINARS]: {
            page: 0,
            pages: 0,
            count: 0,
            values: [],
          },
        },
      };
    case ADD_ADMIN_WEBINARS:
      return {
        ...webinars,
        adminWebinars: {
          values: payload.values || [],
          count: payload.count,
          page: payload.page,
          total_pages: payload.total_pages,
          query: payload.query,
        },
      };
      break;
    case ADD_ADMIN_DASHBOARD_WEBINARS:
      return {
        ...webinars,
        dashboardWebinars: {
          values: payload.values || [],
          count: payload.count,
          page: payload.page,
          total_pages: payload.total_pages,
          total_users: payload.total_users,
        },
      };
      break;
    case SEARCH_WEBINARS:
      return {
        ...webinars,
        isSearching: true,
        isSearchResultsLoading: true,
      };
      break;
    case SAVE_SEARCHED_WEBINARS:
      return {
        ...webinars,
        searchList: payload.webinars,
        isSearching: false,
        isSearchResultsLoading: false,
      };
      break;
    case SAVE_SEARCHED_WEBINARS_TERMS:
      return {
        ...webinars,
        terms: payload.terms,
        isSearching: false,
      };
      break;
    case LOAD_WEBINARS_SAGA:
      const newLoadingCounterSaga = webinars.loadingCounter + 1;
      return {
        ...webinars,
        loadingCounter: newLoadingCounterSaga,
        isLoading: true,
      };
    case LOAD_WEBINARS_COMPLETE:
      const newLoadingCounterComplete = Math.max(
        0,
        webinars.loadingCounter - 1,
      );
      return {
        ...webinars,
        loadingCounter: newLoadingCounterComplete,
        isLoading: newLoadingCounterComplete > 0,
      };
    case SET_ADD_TO_CALLENDAR_LINKS:
      return {
        ...webinars,
        calendarLinks: payload,
      };
    case CLEAR_ADD_TO_CALLENDAR_LINKS:
      return {
        ...webinars,
        calendarLinks: {},
      };
    case CLEAR_TEMP_WEBINAR:
      return { ...webinars, tmp: {} };
    case SET_SYSTEM_FEEDBACKS:
      return {
        ...webinars,
        systemFeedbacks: {
          data: payload.feedbacks,
          count: payload.count,
          totalPages: payload.total_pages,
        },
      };
    case CLEAR_SYSTEM_FEEDBACKS:
      return {
        ...webinars,
        systemFeedbacks: {
          data: [],
          count: 0,
          totalPages: 0,
        },
      };
    case SET_SYSTEM_FEEDBACK:
      return {
        ...webinars,
        systemFeedback: {
          body: payload.body,
          user_name: payload.user_name,
        },
      };
    default:
      return webinars;
  }
};

export { webinars };



// WEBPACK FOOTER //
// ./src/reducers/webinars.js